import Model from "./Model";
import { computed, observable } from "mobx";


class ConditionalFormat extends Model {
  static basePath = '/api/conditional-formats';
  static verboseName = 'ConditionalFormat';

  @observable name;
  @observable red_min;
  @observable red_max;
  @observable orange_min;
  @observable orange_max;
  @observable green_min;
  @observable green_max;
  @observable grey_min;
  @observable grey_max;

  @computed get colorsThresholds() {
    const colorsThresholds = {};
    for (const color of ['red', 'orange', 'green', 'grey']) {
      for (const bound of ['min', 'max']) {
        const prop = `${color}_${bound}`;
        if ((this[prop] !== undefined) && (this[prop] !== null)) {
          if (!(color in colorsThresholds)) {
            colorsThresholds[color] = {};
          }
          colorsThresholds[color][bound] = this[prop];
        }
      }
    }
    return colorsThresholds;
  }

  getColorName(value) {
    for (const [key, thresholds] of Object.entries(this.colorsThresholds)) {
      let min = thresholds.min;
      let max = thresholds.max;
      if (min === undefined) {
        min = -Infinity;
      }
      if (max === undefined) {
        max = Infinity;
      }
      if ((min < max) && (value >= min) && (value < max)) {
        return key;
      }
      if ((min >= max) && ((value >= min) || (value < max))) {
        return key;
      }
    }
    return 'grey';
  }
}


export default ConditionalFormat;
